<template>
  <div class="official-acc-auth-tips">
    <!--    <p class="h2 is-first">1.概述</p>-->
    <p class="content">
      <i18n path="lang.k_061002">
        <template>
          <a class="href" href="https://mp.weixin.qq.com/" target="_blank">
            {{ $t('lang.k_061001') }}
          </a>
        </template>
      </i18n>
    </p>
    <p class="h2 is-first">{{ $t('lang.k_061003') }}</p>
    <p class="content">{{ $t('lang.k_061004') }}</p>
    <p class="content">{{ $t('lang.k_061005') }}</p>
    <p class="content">{{ $t('lang.k_061006') }}</p>
    <p class="content">{{ $t('lang.k_061007') }}</p>
    <p class="h2">{{ $t('lang.k_061008') }}</p>
    <p class="content">{{ $t('lang.k_061009') }}</p>
    <p class="content">
      <img
        class="img"
        src="../../common/images/official/authInstructions_page.png"
        :alt="$t('lang.k_061010')"
      />
    </p>
    <p class="content">{{ $t('lang.k_061011') }}</p>
    <p class="content">
      <img
        class="img"
        src="../../common/images/official/authInstructions_qr.png"
        :alt="$t('lang.k_061010')"
      />
    </p>
    <div>
      <p class="content">{{ $t('lang.k_061013') }}</p>
      <ul class="content">
        <li>{{ $t('lang.k_061014') }}</li>
        <li>{{ $t('lang.k_061015') }}</li>
        <li>{{ $t('lang.k_061016') }}</li>
        <li>{{ $t('lang.k_061017') }}</li>
        <li>{{ $t('lang.k_061018') }}</li>
        <li>{{ $t('lang.k_061019') }}</li>
        <li>{{ $t('lang.k_061020') }}</li>
        <li>{{ $t('lang.k_061021') }}</li>
        <li>{{ $t('lang.k_061022') }}</li>
      </ul>
      <p class="content">
        <!-- prettier-ignore -->
        {{ $t('lang.k_061023') }}
      </p>

      <p class="content">{{ $t('lang.k_061024') }}</p>
      <p class="content">
        {{ $t('lang.k_061025') }}
        <a class="href" href="https://saas-doc.vhall.com/opendocs/show/1548" target="_blank">
          {{ $t('lang.k_061026') }}
        </a>
      </p>
      <!--      <p class="h2">3.订阅号与服务号的区别</p>-->
      <!--      <p class="content mgb0">3.1 接口权限的区别</p>-->
      <!--      <p class="content">图片来源微信官方文档 <a class="href" href="https://developers.weixin.qq.com/doc/offiaccount/Getting_Started/Explanation_of_interface_privileges.html" target="_blank">《接口权限说明》</a></p>-->
      <!--      <p class="content">-->
      <!--        <img-->
      <!--          class="img"-->
      <!--          src="../../common/images/official/authInstructions_privileges.png"-->
      <!--          :alt="$t('lang.k_061010')"-->
      <!--        />-->
      <!--      </p>-->
      <p class="h2">{{ $t('lang.k_061027') }}</p>
      <p class="content mgb0">{{ $t('lang.k_061028') }}</p>
      <p class="content">
        <!-- prettier-ignore -->
        {{ $t('lang.k_061029') }}
      </p>
      <p class="content mgb0">{{ $t('lang.k_061030') }}</p>
      <p class="content">{{ $t('lang.k_061031') }}</p>

      <p class="h2">{{ $t('lang.k_061032') }}</p>
      <p class="content">
        <!-- prettier-ignore -->
        {{ $t('lang.k_061033') }}
      </p>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'AuthInstructions'
  };
</script>

<style lang="less" scoped>
  .official-acc-auth-tips {
    height: 60vh;
    overflow: auto;
    padding-right: 10px;
    .h2 {
      color: #262626;
      text-align: justify;
      font-size: 16px;
      font-style: normal;
      font-weight: 500;
      line-height: 24px;
      margin-bottom: 24px;
      margin-top: 24px;
      &.is-first {
        margin-top: 0px;
      }
    }
    .content {
      color: #262626;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 22px;
      margin-bottom: 12px;
      .href {
        color: #0a7ff5;
      }
      .img {
        width: 512px;
      }
      &.mgb0 {
        margin-bottom: 0px;
      }
    }
    .h3 {
      color: #262626;
      font-size: 14px;
      font-style: normal;
      font-weight: 500;
      line-height: 22px;
    }
  }
</style>
